/* ===== LANUDE · Guía de tallas =====
   Categoría → Método → Medidas → Talla.
   Desde el 11-oct-2026 la categoría solo se pregunta si el Liquid no la
   reconoce: con data-sg-cat la guía abre directo en Método (bras) o en
   Medidas (panties, adhesivos), y la barra de pasos se renumera desde 1.
   Las tablas de medidas viven aquí y solo aquí: no se dibujan en pantalla,
   alimentan el cálculo. Si cambia un rango, cambia en un solo sitio.

   Desde el 15-oct-2026 la guía RECUERDA LAS MEDIDAS durante la sesión
   (sección 8). Se guardan las medidas, no la talla: la misma clienta
   puede ser M en una línea y L en otra, así que en cada ficha la talla se
   vuelve a calcular con la tabla de esa línea. */
(function () {
  "use strict";

  /* =========================================================
     1. DATOS
     ========================================================= */
  var DATA = {
    bras: {
      "Cloud Touch & Cooling Touch": [
        { size: "S",  busto: [72, 80],   base: [64, 70] },
        { size: "M",  busto: [81, 88],   base: [71, 78] },
        { size: "L",  busto: [89, 95],   base: [79, 85] },
        { size: "XL", busto: [96, 105],  base: [86, 93] }
      ],
      "Soft Bonded": [
        { size: "S",  busto: [76, 82],   base: [61, 67] },
        { size: "M",  busto: [83, 89],   base: [68, 74] },
        { size: "L",  busto: [90, 96],   base: [75, 81] },
        { size: "XL", busto: [97, 103],  base: [82, 88] }
      ],
      "Skin Touch": [
        { size: "S",  busto: [83, 89],   base: [68, 74] },
        { size: "M",  busto: [90, 96],   base: [75, 81] },
        { size: "L",  busto: [97, 103],  base: [82, 88] },
        { size: "XL", busto: [104, 110], base: [89, 95] }
      ],
      "Second Skin & Cool Bonding": [
        { size: "S",  busto: [83, 89],   base: [68, 76] },
        { size: "M",  busto: [90, 96],   base: [77, 83] },
        { size: "L",  busto: [97, 103],  base: [84, 90] },
        { size: "XL", busto: [104, 110], base: [91, 97] }
      ],
      "Bra Plus": [
        { size: "L",   busto: [97, 103],  base: [84, 90] },
        { size: "XL",  busto: [104, 110], base: [91, 97] },
        { size: "2XL", busto: [111, 117], base: [98, 104] },
        { size: "3XL", busto: [118, 124], base: [105, 111] }
      ],
      "Top Plus": [
        { size: "L",   busto: [95, 101],  base: [82, 88] },
        { size: "XL",  busto: [102, 108], base: [89, 95] },
        { size: "2XL", busto: [109, 115], base: [96, 102] },
        { size: "3XL", busto: [116, 122], base: [103, 109] }
      ]
    },
    panties: {
      "Butter Line, True Sculpt & Invisible": [
        { size: "S",  cadera: [89, 95] },
        { size: "M",  cadera: [96, 102] },
        { size: "L",  cadera: [103, 109] },
        { size: "XL", cadera: [110, 116] }
      ],
      "Invisible Panty": [
        { size: "S",  cadera: [86, 92] },
        { size: "M",  cadera: [93, 99] },
        { size: "L",  cadera: [100, 106] },
        { size: "XL", cadera: [107, 113] }
      ],
      "True Comfort": [
        { size: "S / M",  cadera: [90, 102] },
        { size: "L / XL", cadera: [103, 115] }
      ]
    },
    adhesivos: {
      "Adhesivos My Skin": [
        { size: "A", h: [13, 16], v: [9, 12] },
        { size: "B", h: [17, 19], v: [13, 15] },
        { size: "C", h: [20, 22], v: [16, 19] }
      ]
    }
  };

  /* Equivalencia copa x banda -> talla en letra */
  var CRUCE = {
    bandas: ["32", "34", "36", "38", "40"],
    copas: {
      A: ["S", "S", "M", "L",  "XL"],
      B: ["S", "M", "M", "XL", "XL"],
      C: ["S", "M", "L", "XL", "-"],
      D: ["M", "L", "L", "XL", "-"]
    }
  };

  var CAMPOS = {
    bras:      [{ key: "busto",  label: "Busto" },      { key: "base", label: "Base" }],
    panties:   [{ key: "cadera", label: "Cadera" }],
    adhesivos: [{ key: "h",      label: "Horizontal" }, { key: "v",    label: "Vertical" }]
  };

  /* =========================================================
     2. TEXTOS Y AJUSTES
     ========================================================= */
  var CATS = [
    { id: "bras",      label: "Brasieres y tops", desc: "Por busto y base, o por tu talla actual." },
    { id: "panties",   label: "Panties",          desc: "Por tu contorno de cadera." },
    { id: "adhesivos", label: "Adhesivos",        desc: "Por tus medidas horizontal y vertical." }
  ];

  /* Solo se ofrecen los métodos que el sistema sabe calcular. */
  var METODOS = {
    bras: [
      { id: "medidas", label: "Con mis medidas",     desc: "Busto y base con cinta métrica. La más precisa." },
      { id: "talla",   label: "Con mi talla actual", desc: "La que ya usas, como 34B o 36A." }
    ],
    panties:   [{ id: "medidas", label: "Con mis medidas", desc: "Tu contorno de cadera con cinta métrica." }],
    adhesivos: [{ id: "medidas", label: "Con mis medidas", desc: "Horizontal y vertical desde el centro." }]
  };

  var CONSEJOS = {
    bras: "Mide sin brasier o con uno sin relleno, con la cinta firme pero sin apretar.",
    panties: "Mide sobre ropa interior delgada, con la cinta paralela al piso.",
    adhesivos: "Mide con el cuerpo relajado y sin sostén."
  };

  var AJUSTES = [
    { id: "cenido",  label: "Ceñido",  d: -1, nota: "Una talla menos: queda más ajustado al cuerpo." },
    { id: "regular", label: "Regular", d: 0,  nota: "La talla que corresponde a tus medidas." },
    { id: "holgado", label: "Holgado", d: 1,  nota: "Una talla más: sensación más libre y ligera." }
  ];

  var ENTRE_COPY = {
    bras:      ["para que no te quede ajustada", "si buscas más compresión"],
    panties:   ["para que no te quede ajustada", "si buscas más compresión"],
    adhesivos: ["para que cubra bien", "si la prefieres más discreta"]
  };

  var REGLA = "mayor";     /* con qué criterio se resuelve un empate entre dos tallas */
  var TOLERANCIA = 2;      /* cm de holgura antes de mandar a asesoría */

  var WA_NUM = "573002658471";
  var WA_CIERRE = "Me gustaría que un experto me asesore.";

  /* A dónde lleva la clienta cuando no se puede agregar al carrito.
     Los handles son los reales de la tienda: /collections/<handle>. */
  var DESTINOS = {
    bras: [
      { label: "Ver brasieres", url: "/collections/essentials" },
      { label: "Ver tops",      url: "/collections/top" }
    ],
    panties:   [{ label: "Ver panties",   url: "/collections/panty" }],
    adhesivos: [{ label: "Ver adhesivos", url: "/collections/adhesivos" }]
  };

  /* Para que el enlace además filtre por talla hacen falta dos cosas en la
     tienda: activar el filtro de talla en Search & Discovery y que la opción
     se llame igual en todos los productos (hoy hay 20 con "Size" y 6 con
     "Talla"). Cuando eso esté, pon aquí el parámetro, por ejemplo
     "filter.v.option.talla", y los botones filtrarán solos. */
  var FILTRO_TALLA = "";

  /* Imágenes de "cómo medirte" */
  var GUIA_IMG = {
    bras: [
      { src: "https://cdn.shopify.com/s/files/1/0870/8446/6489/files/BRA-03.png?v=1773279051",
        alt: "Cinta métrica rodeando el contorno del busto por su parte más alta" },
      { src: "https://cdn.shopify.com/s/files/1/0870/8446/6489/files/BRA-02.png?v=1773279051",
        alt: "Cinta métrica rodeando el torso justo debajo del busto" }
    ],
    panties: [
      { src: "https://cdn.shopify.com/s/files/1/0870/8446/6489/files/PANTI-05.png?v=1773279051",
        alt: "Cinta métrica rodeando la cadera por su parte más ancha" },
      { src: "https://cdn.shopify.com/s/files/1/0870/8446/6489/files/PANTI-04.png?v=1773279051",
        alt: "Vista lateral de la medición de cadera" }
    ]
  };

  var GUIA_TXT = {
    bras: [["1 · Busto:", "contorno por la parte más alta."],
           ["2 · Base:", "justo debajo del busto."]],
    panties: [["Cadera:", "contorno por la parte más ancha, con los pies juntos."]],
    adhesivos: [["1 · Horizontal:", "de lado a lado, desde el centro."],
                ["2 · Vertical:", "de arriba abajo, desde el centro."]]
  };

  /* =========================================================
     3. Iconos
     ========================================================= */
  var SVG = {
    bras: '<path d="M5 4v5M19 4v5"/><path d="M3 10c0 4 2 7 5 7 2 0 3-1.5 4-3 1 1.5 2 3 4 3 3 0 5-3 5-7"/><path d="M3 10h18"/>',
    panties: '<path d="M3 7h18l-2.5 5.5C17 16 14.5 18 12 19c-2.5-1-5-3-6.5-6.5L3 7z"/><path d="M3.8 9h16.4"/>',
    adhesivos: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="2.5"/>',
    medidas: '<circle cx="9" cy="10" r="6"/><circle cx="9" cy="10" r="1.5"/><path d="M9 16h12v-4h-6"/>',
    talla: '<path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    check: '<circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/>',
    bolsa: '<path d="M5 8h14l-1.2 11.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
    hecho: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    flecha: '<path d="M5 12h13M13 6l6 6-6 6"/>'
  };

  function icono(nombre, tam) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"' +
      (tam ? ' style="width:' + tam + 'px;height:' + tam + 'px"' : "") + ">" + SVG[nombre] + "</svg>";
  }

  var WA_ICONO = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0 0 20.465 3.488"/></svg>';

  /* =========================================================
     4. Utilidades y motor de talla
     ========================================================= */
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function dentro(v, r) { return v >= r[0] && v <= r[1]; }
  function distancia(v, r) {
    if (v < r[0]) return r[0] - v;
    if (v > r[1]) return v - r[1];
    return 0;
  }
  function masCercana(filas, key, v) {
    var best = null;
    for (var i = 0; i < filas.length; i++) {
      var d = distancia(v, filas[i][key]);
      if (!best || d < best.d) best = { fila: filas[i], d: d };
    }
    return best;
  }
  function otrasLineas(cat, medidas, excluir, permitidas) {
    var out = [];
    Object.keys(DATA[cat]).forEach(function (linea) {
      if (linea === excluir) return;
      if (permitidas && permitidas.indexOf(linea) < 0) return;
      var hit = DATA[cat][linea].filter(function (fila) {
        return Object.keys(medidas).every(function (k) { return dentro(medidas[k], fila[k]); });
      })[0];
      if (hit) out.push({ linea: linea, size: hit.size });
    });
    return out;
  }

  function resolver(cat, linea, medidas, permitidas) {
    var filas = DATA[cat][linea];
    var keys = Object.keys(medidas);
    var indice = {};
    filas.forEach(function (f, i) { indice[f.size] = i; });

    var exacta = filas.filter(function (fila) {
      return keys.every(function (k) { return dentro(medidas[k], fila[k]); });
    })[0];
    if (exacta) return { estado: "ok", size: exacta.size, linea: linea, fila: exacta, medidas: medidas };

    var porMedida = keys.map(function (k) {
      var b = masCercana(filas, k, medidas[k]);
      return { key: k, size: b.fila.size, d: b.d, fila: b.fila };
    });

    if (porMedida.every(function (p) { return p.d === 0; })) {
      var orden = porMedida.slice().sort(function (a, b) { return indice[a.size] - indice[b.size]; });
      var menor = orden[0], mayor = orden[orden.length - 1];
      var elegida = REGLA === "mayor" ? mayor
        : (porMedida.filter(function (p) { return p.key === REGLA; })[0] || mayor);
      var otra = elegida.size === mayor.size ? menor : mayor;
      return { estado: "entre", size: elegida.size, alterna: otra.size, sube: elegida.size === mayor.size,
               porMedida: porMedida, linea: linea, fila: elegida.fila, medidas: medidas };
    }

    var alternativas = otrasLineas(cat, medidas, linea, permitidas);
    if (alternativas.length) return { estado: "otra-linea", opciones: alternativas, linea: linea, medidas: medidas };

    var maxD = Math.max.apply(null, porMedida.map(function (p) { return p.d; }));
    var cercana = porMedida.filter(function (p) { return p.d === maxD; })[0];
    if (maxD <= TOLERANCIA) {
      return { estado: "justo", size: cercana.size, cm: maxD, linea: linea, fila: cercana.fila, medidas: medidas };
    }
    return { estado: "fuera", linea: linea, medidas: medidas };
  }

  function resolverCopa(copa, banda, linea) {
    var i = CRUCE.bandas.indexOf(banda);
    var size = (CRUCE.copas[copa] || [])[i];
    if (!size || size === "-") return { estado: "sin-equivalencia", copa: copa, banda: banda, linea: linea };
    var fila = DATA.bras[linea].filter(function (f) { return f.size === size; })[0];
    return { estado: "equivalencia", size: size, copa: copa, banda: banda, linea: linea, fila: fila || null };
  }

  function chipsFila(cat, fila) {
    if (!fila) return [];
    return CAMPOS[cat].map(function (c) {
      return c.label + " " + fila[c.key][0] + "–" + fila[c.key][1] + " cm";
    });
  }
  function listaMedidas(cat, medidas) {
    if (!medidas) return "";
    var partes = CAMPOS[cat].filter(function (c) { return medidas[c.key] != null; })
      .map(function (c) { return c.label.toLowerCase() + " " + medidas[c.key] + " cm"; });
    if (partes.length < 2) return partes.join("");
    return partes.slice(0, -1).join(", ") + " y " + partes[partes.length - 1];
  }
  function urlWA(cat, v, producto, diagnostico) {
    var prenda = producto
      ? '"' + producto + '"' + (v.linea ? " (línea " + v.linea + ")" : "")
      : (v.linea ? "la línea " + v.linea : "sus productos");
    var texto = "Hola, estoy interesada en " + prenda + ", " + diagnostico + ".";
    var m = listaMedidas(cat, v.medidas);
    if (m) texto += " Mis medidas son " + m + ".";
    return "https://wa.me/" + WA_NUM + "?text=" + encodeURIComponent(texto + " " + WA_CIERRE);
  }

  /* =========================================================
     5. Una instancia del componente
     ========================================================= */
  var contador = 0;

  /* =========================================================
     8. MEMORIA DE LA SESIÓN
     Al llegar al resultado se guardan las medidas de la clienta en
     sessionStorage, UNA ENTRADA POR TIPO DE PRENDA:
       { brasieres: {…}, tops: {…}, bodys: {…}, sets: {…}, panties: {…}, adhesivos: {…} }
     cada una con { metodo, vals, ajuste }.
     Las tallas de una prenda no sirven para otra, así que cada tipo se
     guarda y se lee por separado. La guía usa la misma tabla para
     brasieres y tops (categoría "bras"), por eso el tipo no sale de la
     categoría sino del nombre del producto (prendaDe, más abajo).
     - Sin la línea: cada ficha pone la suya, y la talla se recalcula con
       su tabla.
     - sessionStorage vive mientras la pestaña esté abierta. Al cerrarla se
       borra solo. No se guarda nada en el servidor ni en la cuenta.
     - Si el navegador bloquea el almacenamiento (modo privado estricto),
       los try/catch hacen que la guía funcione igual, sin recordar.
     En la ficha siguiente de la misma categoría:
       (del mismo tipo de prenda)
       el enlace pasa a decir "Guía de tallas · Tu talla: M" y la guía abre
       directo en el resultado, con "Editar mis medidas" a mano.
     ========================================================= */
  var MEMORIA = "lnd-sg-medidas";

  function leerMemoria() {
    try { return JSON.parse(window.sessionStorage.getItem(MEMORIA)) || {}; }
    catch (e) { return {}; }
  }
  /* Tipo de prenda para la memoria. Primero la categoría de la guía;
     dentro de "bras" se separa por el nombre del producto. Para afinar,
     agrega palabras a estas expresiones. */
  var PRENDAS_BRAS = [
    { id: "bodys", re: /\bbody(suit)?s?\b/i },
    { id: "sets",  re: /\b(sets?|conjuntos?|combos?)\b/i },
    { id: "tops",  re: /\btops?\b/i }
  ];
  function prendaDe(cat, producto) {
    if (cat !== "bras") return cat;            /* panties, adhesivos */
    for (var i = 0; i < PRENDAS_BRAS.length; i++) {
      if (PRENDAS_BRAS[i].re.test(producto)) return PRENDAS_BRAS[i].id;
    }
    return "brasieres";
  }

  function guardarMemoria(prenda, dato) {
    try {
      var m = leerMemoria();
      m[prenda] = dato;
      window.sessionStorage.setItem(MEMORIA, JSON.stringify(m));
    } catch (e) { /* sin almacenamiento: no se recuerda, y ya */ }
  }

  function iniciar(raiz) {
    if (raiz.hasAttribute("data-sg-listo")) return;
    raiz.setAttribute("data-sg-listo", "");

    var uid = "lnd-sg-" + (++contador);
    var overlay = raiz.querySelector("[data-sg-overlay]");
    var caja = raiz.querySelector("[data-sg-box]");
    var abrir = raiz.querySelector("[data-sg-open]");
    if (!overlay || !caja || !abrir) return;

    document.body.appendChild(overlay);

    var titulo = overlay.querySelector("[data-sg-title]");
    titulo.id = uid + "-title";
    caja.setAttribute("aria-labelledby", titulo.id);
    overlay.id = uid + "-dialog";
    abrir.setAttribute("aria-controls", overlay.id);

    var q = function (sel) { return overlay.querySelector(sel); };
    var CATS_ID = ["bras", "panties", "adhesivos"];

    /* --- contexto del producto --- */
    function leerJSON(attr, porDefecto) {
      try { return JSON.parse(raiz.getAttribute(attr) || "") || porDefecto; }
      catch (e) { return porDefecto; }
    }
    var PRODUCTO = (raiz.getAttribute("data-sg-producto") || "").trim();
    var IMAGEN = (raiz.getAttribute("data-sg-imagen") || "").trim();
    var OPCIONES = leerJSON("data-sg-opciones", []);
    var VARIANTES = leerJSON("data-sg-variantes", []);
    var iTalla = OPCIONES.map(function (o) { return String(o).toLowerCase(); })
      .findIndex(function (o) { return /talla|size/.test(o); });

    var pedidas = (raiz.getAttribute("data-sg-lineas") || "").split("||")
      .map(function (x) { return x.trim(); }).filter(Boolean);
    var catProducto = (raiz.getAttribute("data-sg-cat") || "").trim().toLowerCase();
    if (CATS_ID.indexOf(catProducto) < 0) catProducto = "";

    function partes(clave) {
      return clave.split(/[&,]/).map(function (x) { return x.trim().toLowerCase(); });
    }
    function resolverNombre(cat, pedida) {
      var claves = Object.keys(DATA[cat]), qn = pedida.toLowerCase();
      var exacta = claves.filter(function (k) { return k.toLowerCase() === qn; });
      if (exacta.length) return exacta;
      var porParte = claves.filter(function (k) { return partes(k).indexOf(qn) >= 0; });
      if (porParte.length) return porParte;
      return claves.filter(function (k) { return k.toLowerCase().indexOf(qn) >= 0; });
    }
    var reconocidas = {};
    CATS_ID.forEach(function (cat) {
      var acc = [];
      pedidas.forEach(function (p) {
        resolverNombre(cat, p).forEach(function (k) { if (acc.indexOf(k) < 0) acc.push(k); });
      });
      reconocidas[cat] = Object.keys(DATA[cat]).filter(function (k) { return acc.indexOf(k) >= 0; });
    });

    /* --- Si el metacampo no dice la línea, se deduce del producto ---
       Los nombres de línea viven en el propio nombre del producto: "Cool
       Bonding - Top Frío" es de "Second Skin & Cool Bonding". Se busca cada
       parte del nombre de la línea (separadas por & o coma) como palabras
       completas en el título, y en data-sg-pistas si el bloque las publica
       (tipo, etiquetas, colecciones).
       Gana la coincidencia más larga: "Invisible Panty" le gana a la parte
       "Invisible" de "Butter Line, True Sculpt & Invisible". Si nada
       coincide, la lista queda vacía y la guía sí pregunta la línea. */
    function normal(t) {
      return String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, " ").trim();
    }
    var PISTAS = " " + normal(PRODUCTO + " " + (raiz.getAttribute("data-sg-pistas") || "")) + " ";
    function deducidas(cat) {
      var mejor = 0, out = [];
      Object.keys(DATA[cat]).forEach(function (k) {
        var largo = 0;
        partes(k).forEach(function (pt) {
          var n = normal(pt);
          if (n.length >= 4 && PISTAS.indexOf(" " + n + " ") >= 0) largo = Math.max(largo, n.length);
        });
        if (!largo) return;
        if (largo > mejor) { mejor = largo; out = [k]; }
        else if (largo === mejor) out.push(k);
      });
      return out;
    }
    CATS_ID.forEach(function (cat) {
      if (!reconocidas[cat].length) reconocidas[cat] = deducidas(cat);
    });
    function lineasDe(cat) {
      return reconocidas[cat].length ? reconocidas[cat] : Object.keys(DATA[cat]);
    }
    /* La línea del producto sale del metacampo (data-sg-lineas). Si se
       reconoce, se usa por debajo y el campo "Línea" no se muestra: es un
       nombre interno de colección que una clienta nueva no sabe qué es, y
       preguntárselo solo suma carga. Si el producto trae varias, se toma la
       primera; el cálculo igual revisa las demás y avisa si su talla está en
       otra. Solo cuando el producto no tiene línea reconocible se pregunta. */
    function lineaFija(cat) {
      return reconocidas[cat].length ? reconocidas[cat][0] : null;
    }

    /* --- estado --- */
    var st = { paso: 0, cat: catProducto || "bras", metodo: null, vals: {},
               ajuste: "regular", sel: null, agregado: false };
    var temporizador = null;

    /* Si el Liquid ya sabe qué prenda es (data-sg-cat), preguntar
       "¿Qué quieres medir?" sobra: la guía arranca directo en lo que hay
       que medir, y ese pasa a ser el paso 1. Solo cuando el Liquid no la
       reconoce (data-sg-cat vacío) se muestra la elección de categoría. */
    var SALTA_CATEGORIA = !!catProducto;
    function primerPaso() {
      if (!SALTA_CATEGORIA) return 0;
      return unSoloMetodo(st.cat) ? 2 : 1;   /* bras: aún hay que elegir método */
    }

    function metodosDe(cat) { return METODOS[cat] || []; }
    function unSoloMetodo(cat) { return metodosDe(cat).length === 1; }

    /* --- definición de campos, según categoría y método --- */
    function rango(a, b) {
      var out = [];
      for (var n = a; n <= b; n++) out.push({ v: n, label: n + " cm" });
      return out;
    }
    function opcionesLinea(cat) {
      return lineasDe(cat).map(function (l) { return { v: l, label: l }; });
    }
    function defs(cat, metodo) {
      return camposDe(cat, metodo).filter(Boolean);
    }
    function camposDe(cat, metodo) {
      var linea = lineaFija(cat) ? null
        : { key: "linea", label: "Línea", tipo: "select", opciones: opcionesLinea(cat) };
      if (cat === "bras" && metodo === "medidas") {
        return [linea,
          { key: "busto", label: "1 · Busto", tipo: "select", opciones: rango(65, 130) },
          { key: "base",  label: "2 · Base",  tipo: "select", opciones: rango(55, 115) }];
      }
      if (cat === "bras") {
        return [linea,
          { key: "banda", label: "Banda", tipo: "chips", opciones: CRUCE.bandas.map(function (b) { return { v: b, label: b }; }) },
          { key: "copa",  label: "Copa",  tipo: "chips", opciones: Object.keys(CRUCE.copas).map(function (c) { return { v: c, label: c }; }) }];
      }
      if (cat === "panties") {
        return [linea, { key: "cadera", label: "Cadera", tipo: "select", opciones: rango(80, 120) }];
      }
      return [
        { key: "h", label: "1 · Horizontal", tipo: "select", opciones: rango(10, 26) },
        { key: "v", label: "2 · Vertical",   tipo: "select", opciones: rango(6, 22) }];
    }

    /* --- veredicto --- */
    function veredicto() {
      var cat = st.cat, v = st.vals;
      if (!v.linea && lineaFija(cat)) v.linea = lineaFija(cat);
      if (cat === "bras" && st.metodo === "talla") {
        return resolverCopa(v.copa, v.banda, v.linea);
      }
      var medidas = {};
      CAMPOS[cat].forEach(function (c) { medidas[c.key] = Number(v[c.key]); });
      var linea = v.linea || lineasDe(cat)[0];
      return resolver(cat, linea, medidas, reconocidas[cat].length ? lineasDe(cat) : null);
    }

    /* =========================================================
       6. Render
       ========================================================= */
    function pasosVisibles() {
      var out = SALTA_CATEGORIA ? [] : [{ i: 0, label: "Categoría" }];
      if (!unSoloMetodo(st.cat)) out.push({ i: 1, label: "Método" });
      out.push({ i: 2, label: st.metodo === "talla" ? "Tu talla" : "Medidas" });
      out.push({ i: 3, label: "Resultado" });
      return out;
    }

    function pintarPasos() {
      var vis = pasosVisibles();
      q("[data-sg-pasos]").innerHTML = vis.map(function (p, n) {
        return '<li class="' + (st.paso >= p.i ? "is-hecho" : "") + '"><i></i><span>' +
          (n + 1) + " · " + esc(p.label) + "</span></li>";
      }).join("");
      q("[data-sg-pasos]").style.gridTemplateColumns = "repeat(" + vis.length + ", minmax(0, 1fr))";
      /* el subtítulo decía "en 4 pasos" fijo; ahora cuenta los que hay */
      var lead = overlay.querySelector(".lnd-sg-lead");
      if (lead) lead.textContent = "Encuentra tu ajuste ideal en " + vis.length + " pasos.";
    }

    function pintarCats() {
      q("[data-sg-cats]").innerHTML = CATS.map(function (c) {
        var sel = st.cat === c.id;
        return '<button type="button" class="lnd-sg-tarjeta" data-cat="' + c.id + '" aria-pressed="' + sel + '">' +
          '<span class="lnd-sg-tar-icono">' + icono(c.id) + "</span>" +
          '<span class="lnd-sg-tar-txt"><span class="lnd-sg-tar-titulo">' + esc(c.label) + "</span>" +
          '<span class="lnd-sg-tar-desc">' + esc(c.desc) + "</span></span>" +
          (c.id === catProducto ? '<span class="lnd-sg-tar-marca">Lo estás viendo</span>' : "") +
          "</button>";
      }).join("");
    }

    function pintarMetodos() {
      var ms = metodosDe(st.cat);
      q("[data-sg-metodos]").innerHTML = ms.map(function (m) {
        var sel = st.metodo === m.id;
        return '<button type="button" class="lnd-sg-tarjeta" data-metodo="' + m.id + '" aria-pressed="' + sel + '">' +
          '<span class="lnd-sg-tar-icono">' + icono(m.id === "medidas" ? "medidas" : "talla") + "</span>" +
          '<span class="lnd-sg-tar-txt"><span class="lnd-sg-tar-titulo">' + esc(m.label) + "</span>" +
          '<span class="lnd-sg-tar-desc">' + esc(m.desc) + "</span></span></button>";
      }).join("");
      q("[data-sg-consejo]").innerHTML = icono("info", 20) + "<span>" + esc(CONSEJOS[st.cat]) + "</span>";
    }

    function pintarGuia() {
      var cont = q("[data-sg-guia]");
      if (st.metodo !== "medidas") { cont.innerHTML = ""; return; }
      var textos = (GUIA_TXT[st.cat] || []).map(function (t) {
        return "<span><strong>" + esc(t[0]) + "</strong> " + esc(t[1]) + "</span>";
      }).join("");
      var imgs = (GUIA_IMG[st.cat] || []).map(function (i) {
        return '<img src="' + esc(i.src) + '" alt="' + esc(i.alt) + '" loading="lazy" width="80" height="80">';
      }).join("");
      cont.innerHTML = '<div class="lnd-sg-guia"><div class="lnd-sg-guia-txt">' + textos +
        "<em>Cinta paralela al piso y sin apretar.</em></div>" +
        (imgs ? '<div class="lnd-sg-guia-img">' + imgs + "</div>" : "") + "</div>";
    }

    function pintarCampos() {
      var fs = defs(st.cat, st.metodo);
      var libre = true;
      q("[data-sg-titulo-campos]").textContent = st.metodo === "medidas"
        ? "Tus medidas"
        : "¿Qué talla usas hoy?";

      q("[data-sg-campos]").innerHTML = fs.map(function (f, j) {
        var val = st.vals[f.key];
        var bloqueado = !libre;
        var hecho = val != null && val !== "";
        if (!hecho) libre = false;
        var id = uid + "-" + f.key;

        var top = '<div class="lnd-sg-campo-top">' +
          (f.tipo === "select"
            ? '<label for="' + id + '">' + esc(f.label) + "</label>"
            : '<span class="lnd-sg-etiqueta" id="' + id + '-lab">' + esc(f.label) + "</span>") +
          (hecho ? icono("check", 18) : "") +
          (bloqueado ? '<span class="lnd-sg-campo-aviso">Completa el campo anterior</span>' : "") +
          "</div>";

        var control;
        if (f.tipo === "select") {
          control = '<select class="lnd-sg-select' + (!bloqueado && !hecho ? " is-pendiente" : "") +
            '" id="' + id + '" data-campo="' + f.key + '"' + (bloqueado ? " disabled" : "") + ">" +
            '<option value="">Selecciona</option>' +
            f.opciones.map(function (o) {
              return '<option value="' + esc(o.v) + '"' + (String(o.v) === String(val) ? " selected" : "") +
                ">" + esc(o.label) + "</option>";
            }).join("") + "</select>";
        } else {
          control = '<div class="lnd-sg-chips-grid' + (f.opciones.length === 4 ? " lnd-sg-chips-grid--4" : "") +
            '" role="group" aria-labelledby="' + id + '-lab">' +
            f.opciones.map(function (o) {
              return '<button type="button" class="lnd-sg-chip" data-campo="' + f.key +
                '" data-valor="' + esc(o.v) + '" aria-pressed="' + (String(o.v) === String(val)) + '"' +
                (bloqueado ? " disabled" : "") + ">" + esc(o.label) + "</button>";
            }).join("") + "</div>";
        }
        return '<div class="lnd-sg-campo' + (bloqueado ? " is-bloqueado" : "") + '">' + top + control + "</div>";
      }).join("");
    }

    /* --- paso 4 --- */
    function filasDe(v) { return DATA[st.cat][v.linea] || []; }

    function tallaAjustada(v) {
      var filas = filasDe(v);
      var i = filas.map(function (f) { return f.size; }).indexOf(v.size);
      if (i < 0) return { size: v.size, fila: v.fila };
      var d = (AJUSTES.filter(function (a) { return a.id === st.ajuste; })[0] || AJUSTES[1]).d;
      var j = Math.max(0, Math.min(filas.length - 1, i + d));
      return { size: filas[j].size, fila: filas[j] };
    }

    function pintarAjuste(v) {
      var cont = q("[data-sg-ajuste]");
      if (!v.size || filasDe(v).length < 2) { cont.innerHTML = ""; return; }
      var filas = filasDe(v);
      var i = filas.map(function (f) { return f.size; }).indexOf(v.size);
      if (i < 0) { cont.innerHTML = ""; return; }
      var nota = (AJUSTES.filter(function (a) { return a.id === st.ajuste; })[0] || AJUSTES[1]).nota;
      cont.innerHTML = '<div class="lnd-sg-ajuste">' +
        '<h3 class="lnd-sg-h2">¿Cómo te gusta que te quede?</h3>' +
        '<div class="lnd-sg-ajuste-ops" role="group" aria-label="Preferencia de ajuste">' +
        AJUSTES.map(function (a) {
          return '<button type="button" class="lnd-sg-ajuste-op" data-ajuste="' + a.id +
            '" aria-pressed="' + (st.ajuste === a.id) + '"><b>' + esc(a.label) + "</b></button>";
        }).join("") + "</div>" +
        '<p class="lnd-sg-ajuste-nota">' + esc(nota) + "</p></div>";
    }

    function pintarResultado(v) {
      var cat = st.cat;
      var t = { aviso: false, size: null, fila: null, cejilla: "", titulo: "", chips: [], nota: "", wa: null };

      if (v.estado === "ok" || v.estado === "justo" || (v.estado === "equivalencia" && v.fila)) {
        var aj = tallaAjustada(v);
        t.size = aj.size; t.fila = aj.fila;
        t.cejilla = "Tu talla";
        t.titulo = "Talla " + aj.size + " en " + v.linea;
        t.chips = (v.estado === "equivalencia" ? ["Equivale a " + v.banda + v.copa] : []).concat(chipsFila(cat, aj.fila));
        if (v.estado === "justo") {
          t.nota = "Tus medidas quedan " + v.cm.toFixed(1).replace(".0", "") + " cm fuera del rango.";
          t.wa = "pero tengo dudas sobre mi talla: la guía me indica " + v.size +
            " como la más cercana, aunque mis medidas quedan " +
            v.cm.toFixed(1).replace(".0", "") + " cm fuera del rango";
        }

      } else if (v.estado === "entre") {
        var frase = ENTRE_COPY[cat] || ENTRE_COPY.bras;
        var aj2 = tallaAjustada(v);
        t.size = aj2.size; t.fila = aj2.fila;
        t.cejilla = "Estás entre dos tallas";
        t.titulo = "Talla " + aj2.size + " en " + v.linea;
        t.chips = v.porMedida.map(function (pm) {
          var nombre = CAMPOS[cat].filter(function (c) { return c.key === pm.key; })[0].label;
          return nombre + " → " + pm.size;
        });
        t.nota = "Te recomendamos la " + v.size + " " + (v.sube ? frase[0] : "") + "; " +
          frase[1] + ", la " + v.alterna + ".";
        t.wa = "pero tengo dudas sobre mi talla: la guía me deja entre dos (" + t.chips.join(" · ") + ")";

      } else if (v.estado === "equivalencia") {
        t.aviso = true; t.size = v.size;
        t.cejilla = "Equivalencia encontrada";
        t.titulo = "La " + v.banda + v.copa + " equivale a la talla " + v.size;
        t.nota = "En " + v.linea + " no manejamos esa talla.";
        t.wa = "pero tengo dudas sobre mi talla: uso " + v.banda + v.copa +
          ", que la guía equipara a la " + v.size + ", y no aparece en esa línea";

      } else if (v.estado === "otra-linea") {
        t.aviso = true; t.size = v.opciones[0].size;
        t.cejilla = "Disponible en otra línea";
        t.titulo = "En " + v.linea + " no hay una talla para tus medidas";
        t.chips = v.opciones.slice(0, 3).map(function (o) { return o.size + " en " + o.linea; });

      } else if (v.estado === "sin-equivalencia") {
        t.aviso = true;
        t.cejilla = "Sin equivalencia";
        t.titulo = "No tenemos equivalencia para la " + v.banda + v.copa;
        t.nota = "Te ayudamos a encontrar tu talla.";
        t.wa = "pero no encuentro la equivalencia de mi talla " + v.banda + v.copa + " en la guía";

      } else {
        t.aviso = true;
        t.cejilla = "Sin talla en la guía";
        t.titulo = "Tus medidas quedan fuera de nuestras tablas";
        t.nota = "Te ayudamos a elegir la talla correcta.";
        t.wa = "pero mis medidas no aparecen en la guía de tallas";
      }

      var html = '<div class="lnd-sg-res' + (t.aviso ? " is-aviso" : "") + '">';
      if (t.size) html += '<span class="lnd-sg-badge">' + esc(t.size) + "</span>";
      html += '<span class="lnd-sg-res-txt">' +
        '<span class="lnd-sg-res-cejilla">' + esc(t.cejilla) + "</span>" +
        '<span class="lnd-sg-res-titulo">' + esc(t.titulo) + "</span>";
      if (t.chips.length) {
        html += '<ul class="lnd-sg-chips">' +
          t.chips.map(function (c) { return "<li>" + esc(c) + "</li>"; }).join("") + "</ul>";
      }
      if (t.nota) html += '<span class="lnd-sg-res-nota">' + esc(t.nota) + "</span>";
      html += "</span></div>";
      q("[data-sg-resultado]").innerHTML = html;
      return t;
    }

    var mismo = function (a, b) {
      return String(a == null ? "" : a).toLowerCase() === String(b == null ? "" : b).toLowerCase();
    };

    function hayPicker() { return iTalla >= 0 && VARIANTES.length > 0 && OPCIONES.length > 0; }

    /* Un valor sin unidades en NINGUNA talla no se ofrece: no hay nada que
       comprar, así que mostrarlo solo suma ruido y frustración. */
    function vendible(i, valor) {
      return VARIANTES.some(function (v) { return v.d && mismo(v.o[i], valor); });
    }

    /* ¿Todos los valores de esta variante (salvo la talla) siguen a la venta? */
    function combinacionVendible(v) {
      return OPCIONES.every(function (n, i) { return i === iTalla || vendible(i, v.o[i]); });
    }

    /* Primera combinación disponible que use esa talla; si no hay stock,
       la primera que exista, para poder mostrarla como agotada. */
    function seleccionPara(size, previa) {
      if (!hayPicker()) return null;
      /* si el color que ya eligió existe en la nueva talla, se respeta */
      if (previa) {
        var conserva = previa.slice();
        conserva[iTalla] = size;
        var v = variantePara(conserva);
        if (v && v.d) return conserva;
      }
      var conStock = VARIANTES.filter(function (x) { return x.d && mismo(x.o[iTalla], size); })[0];
      var conColorVigente = VARIANTES.filter(function (x) {
        return mismo(x.o[iTalla], size) && combinacionVendible(x);
      })[0];
      var cualquiera = VARIANTES.filter(function (x) { return mismo(x.o[iTalla], size); })[0];
      var base = conStock || conColorVigente || cualquiera;
      return base ? base.o.slice() : null;
    }

    function variantePara(sel) {
      if (!sel) return null;
      return VARIANTES.filter(function (v) {
        return sel.every(function (val, i) { return mismo(v.o[i], val); });
      })[0] || null;
    }

    /* ¿Existe stock con este valor en la posición i, respetando el resto? */
    function hayStock(i, valor, sel) {
      return VARIANTES.some(function (v) {
        return v.d && mismo(v.o[i], valor) && sel.every(function (val, j) {
          return j === i || mismo(v.o[j], val);
        });
      });
    }

    /* Al cambiar un valor, se reacomodan los demás para no dejar
       a la clienta en una combinación que no existe. */
    function elegirValor(i, valor) {
      var sel = (st.sel || []).slice();
      var talla = sel[iTalla];
      sel[i] = valor;
      if (!variantePara(sel)) {
        /* se busca una combinación existente que respete el valor elegido
           Y la talla calculada, que aquí no se negocia */
        var mismaTalla = VARIANTES.filter(function (v) {
          return mismo(v.o[i], valor) && mismo(v.o[iTalla], talla);
        });
        var arreglo =
          mismaTalla.filter(function (v) { return v.d; })[0] ||
          mismaTalla.filter(combinacionVendible)[0] ||
          mismaTalla[0];
        if (arreglo) sel = arreglo.o.slice();
      }
      st.sel = sel;
      st.agregado = false;
    }

    /* Valores ofrecibles de la opción i, en el orden del catálogo.
       Se omiten los agotados en todas las tallas. */
    function valoresDe(i) {
      var out = [];
      VARIANTES.forEach(function (v) {
        var x = v.o[i];
        if (x == null) return;
        if (out.some(function (y) { return mismo(y, x); })) return;
        if (!vendible(i, x)) return;
        out.push(x);
      });
      return out;
    }

    function imagenDe(i, valor) {
      var v = VARIANTES.filter(function (x) { return mismo(x.o[i], valor) && x.im; })[0];
      return v ? v.im : "";
    }

    function pintarCierre(v, t) {
      var cont = q("[data-sg-cierre]");
      if (!t.size) { cont.innerHTML = '<div class="lnd-sg-cierre">' + bloqueWA(v, t) + editar() + "</div>"; return; }

      /* la talla recomendada manda: si cambió, la selección se rehace */
      if (hayPicker() && (!st.sel || !mismo(st.sel[iTalla], t.size))) st.sel = seleccionPara(t.size, st.sel);

      if (!hayPicker() || !st.sel) {
        cont.innerHTML = '<div class="lnd-sg-cierre">' + destinos(t.size) + bloqueWA(v, t) + editar() + "</div>";
        return;
      }

      var variante = variantePara(st.sel);
      var disponible = !!(variante && variante.d);
      var tallaSel = st.sel[iTalla];
      /* en la ficha solo se nombran valores que sigan a la venta: anunciar un
         color retirado deja a la clienta buscando algo que no existe */
      var otras = st.sel.filter(function (x, i) { return i !== iTalla && vendible(i, x); }).join(" · ");
      var img = imagenDe(iTalla, tallaSel);
      OPCIONES.forEach(function (n, i) {
        if (i === iTalla || !vendible(i, st.sel[i])) return;
        if (imagenDe(i, st.sel[i])) img = imagenDe(i, st.sel[i]);
      });

      var html = '<div class="lnd-sg-cierre">';

      html += '<div class="lnd-sg-prod">' +
        (img || IMAGEN
          ? '<img src="' + esc(img || IMAGEN) + '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="lnd-sg-prod-ph"></span>') +
        '<span class="lnd-sg-prod-txt">' +
        '<span class="lnd-sg-prod-nombre">' + esc(PRODUCTO || "Este producto") + "</span>" +
        '<span class="lnd-sg-prod-meta">Talla ' + esc(tallaSel) + (otras ? " · " + esc(otras) : "") + "</span>" +
        "</span>" +
        (variante && variante.p ? '<span class="lnd-sg-prod-precio">' + esc(variante.p) + "</span>" : "") +
        "</div>";

      /* Filas a mostrar: la talla ya la decidió el paso de ajuste, así que
         aquí solo se elige color. Una fila con un único valor ya elegido no
         es una decisión, así que no se pinta. */
      var filas = [];
      OPCIONES.forEach(function (nombre, i) {
        if (i === iTalla) return;
        var vals = valoresDe(i);
        if (!vals.length) return;
        if (vals.length === 1 && mismo(st.sel[i], vals[0])) return;
        filas.push({ i: i, nombre: nombre, vals: vals });
      });

      if (filas.length) {
        html += '<div class="lnd-sg-var">';
        filas.forEach(function (fila) {
          var i = fila.i;
          var elegido = fila.vals.some(function (val) { return mismo(st.sel[i], val); });
          html += '<div class="lnd-sg-var-fila">' +
            '<span class="lnd-sg-var-lab" id="' + uid + "-op" + i + '">' + esc(fila.nombre) +
            (elegido ? ": <b>" + esc(st.sel[i]) + "</b>" : "") + "</span>" +
            '<div class="lnd-sg-opciones" role="radiogroup" aria-labelledby="' + uid + "-op" + i + '">' +
            fila.vals.map(function (val) {
              var stock = hayStock(i, val, st.sel);
              var sel = elegido && mismo(st.sel[i], val);
              var im = imagenDe(i, val);
              return '<button type="button" class="lnd-sg-sw' + (stock ? "" : " lnd-sg-agotado") +
                '" data-op="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + sel + '" title="' +
                esc(val) + (stock ? "" : " · agotado en esta talla") + '">' +
                '<span class="lnd-sg-sw-img"' + (im ? ' data-im="' + esc(im) + '"' : "") + "></span>" +
                '<span class="lnd-sg-sw-nom">' + esc(val) + "</span>" +
                (stock ? "" : '<span class="lnd-sg-vh">Agotado en esta talla</span>') +
                "</button>";
            }).join("") + "</div></div>";
        });
        html += "</div>";
      }

      if (disponible) {
        html += '<button type="button" class="lnd-sg-cta" data-agregar="' + variante.id + '">' +
          icono("bolsa", 20) + "<span>Agregar al carrito · Talla " + esc(tallaSel) + "</span></button>";
      } else {
        html += '<button type="button" class="lnd-sg-cta" disabled>' +
          "<span>Sin stock en esta combinación</span></button>" + destinos(t.size);
      }

      html += bloqueWA(v, t) + editar() + "</div>";
      cont.innerHTML = html;

      /* la foto de la variante se asigna por JS: una URL con comillas o
         paréntesis rompería el atributo style */
      cont.querySelectorAll("[data-im]").forEach(function (el) {
        el.style.backgroundImage = 'url("' + el.getAttribute("data-im").replace(/"/g, "%22") + '")';
      });
    }

    function destinos(size) {
      var ds = DESTINOS[st.cat] || [];
      if (!ds.length) return "";
      return '<div class="lnd-sg-destinos">' + ds.map(function (d) {
        var url = d.url + (FILTRO_TALLA ? "?" + FILTRO_TALLA + "=" + encodeURIComponent(size) : "");
        return '<a class="lnd-sg-cta" href="' + esc(url) + '"><span>' + esc(d.label) + "</span>" +
          icono("flecha", 20) + "</a>";
      }).join("") + "</div>";
    }

    function bloqueWA(v, t) {
      if (!t.wa) return "";
      return '<a class="lnd-sg-wa" href="' + esc(urlWA(st.cat, v, PRODUCTO, t.wa)) +
        '" target="_blank" rel="noopener">' + WA_ICONO +
        "<span>Solicitar asesoría personalizada</span></a>";
    }

    function editar() {
      return '<button type="button" class="lnd-sg-texto" data-editar>Editar mis medidas</button>';
    }

    function pintarPaso3() {
      var v = veredicto();
      pintarAjuste(v);
      var t = pintarResultado(v);
      pintarCierre(v, t);
      recordar();
      marcarDisparador(t);
    }

    /* Memoria (sección 8): se guardan las medidas tal como las dio la
       clienta, sin la línea. */
    function recordar() {
      var vals = {};
      Object.keys(st.vals).forEach(function (k) { if (k !== "linea") vals[k] = st.vals[k]; });
      guardarMemoria(prendaDe(st.cat, PRODUCTO), { metodo: st.metodo, vals: vals, ajuste: st.ajuste });
    }

    /* "Guía de tallas · Tu talla: M". Solo con una talla firme: si el
       resultado es un aviso (otra línea, sin equivalencia, fuera de tabla)
       el enlace se queda como estaba. */
    function marcarDisparador(t) {
      var marca = abrir.querySelector(".lnd-sg-tu-talla");
      if (!t || !t.size || t.aviso) { if (marca) marca.remove(); return; }
      if (!marca) {
        marca = document.createElement("span");
        marca.className = "lnd-sg-tu-talla";
        abrir.appendChild(marca);
      }
      marca.textContent = "· Tu talla: " + t.size;
    }

    function render(foco) {
      pintarPasos();
      if (st.paso === 0) pintarCats();
      if (st.paso === 1) pintarMetodos();
      if (st.paso === 2) { pintarGuia(); pintarCampos(); }
      if (st.paso === 3) pintarPaso3();

      overlay.querySelectorAll("[data-paso]").forEach(function (sec) {
        sec.hidden = Number(sec.getAttribute("data-paso")) !== st.paso;
      });
      q("[data-sg-back]").hidden = st.paso <= primerPaso();
      q("[data-sg-body]").scrollTop = 0;
      if (foco) {
        var activo = overlay.querySelector('[data-paso="' + st.paso + '"]');
        if (activo) activo.focus();
      }
    }

    /* =========================================================
       7. Navegación e interacción
       ========================================================= */
    function irA(n, foco) {
      clearTimeout(temporizador);
      st.paso = n;
      render(foco);
    }
    function atras() {
      if (st.paso === 3) return irA(2, true);
      if (st.paso === 2 && !unSoloMetodo(st.cat)) return irA(1, true);
      if (st.paso === 2 && !SALTA_CATEGORIA) return irA(0, true);
      if (st.paso === 1 && !SALTA_CATEGORIA) return irA(0, true);
    }
    function tras(cat) {
      st.cat = cat;
      st.vals = {};
      st.agregado = false;
      var ms = metodosDe(cat);
      if (ms.length === 1) { st.metodo = ms[0].id; irA(2, true); }
      else { st.metodo = null; irA(1, true); }
    }

    q("[data-sg-back]").addEventListener("click", atras);

    q("[data-sg-cats]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-cat]");
      if (b) tras(b.getAttribute("data-cat"));
    });

    q("[data-sg-metodos]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-metodo]");
      if (!b) return;
      st.metodo = b.getAttribute("data-metodo");
      st.vals = {};
      st.agregado = false;
      irA(2, true);
    });

    function fijar(key, valor) {
      st.vals[key] = valor;
      st.sel = null;
      st.agregado = false;
      var fs = defs(st.cat, st.metodo);
      var completo = fs.every(function (f) {
        return st.vals[f.key] != null && st.vals[f.key] !== "";
      });
      render(false);
      if (completo) {
        clearTimeout(temporizador);
        temporizador = setTimeout(function () { st.ajuste = "regular"; irA(3, true); }, 420);
      }
    }

    q("[data-sg-campos]").addEventListener("change", function (e) {
      var s = e.target.closest("select[data-campo]");
      if (s) fijar(s.getAttribute("data-campo"), s.value);
    });
    q("[data-sg-campos]").addEventListener("click", function (e) {
      var b = e.target.closest("button[data-campo]");
      if (b && !b.disabled) fijar(b.getAttribute("data-campo"), b.getAttribute("data-valor"));
    });

    q("[data-sg-ajuste]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-ajuste]");
      if (!b) return;
      st.ajuste = b.getAttribute("data-ajuste");
      st.agregado = false;
      pintarPaso3();
    });

    q("[data-sg-cierre]").addEventListener("click", function (e) {
      if (e.target.closest("[data-editar]")) { irA(2, true); return; }
      var op = e.target.closest("[data-op]");
      if (op) {
        elegirValor(Number(op.getAttribute("data-op")), op.getAttribute("data-val"));
        pintarPaso3();
        return;
      }
      var add = e.target.closest("[data-agregar]");
      if (!add) return;
      var id = Number(add.getAttribute("data-agregar"));
      add.disabled = true;
      add.innerHTML = icono("bolsa", 20) + "<span>Agregando…</span>";
      agregarAlCarrito(id).then(function (res) {
        /* la guía se cierra como si diera a la X; el carrito del tema
           es ahora la confirmación */
        cerrarModal(!!res.cajon);
        if (res.cajon) {
          setTimeout(function () { res.cajon.show(); }, 240);
        } else if (res.irAlCarrito) {
          window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || "/cart";
        }
      }).catch(function () {
        add.disabled = false;
        add.innerHTML = icono("bolsa", 20) + "<span>No se pudo agregar. Intenta de nuevo</span>";
      });
    });

    /* Agregar replicando lo que hace el propio tema al enviar un
       product-form. Un POST suelto a /cart/add.js sí mete el artículo,
       pero deja el contador del header y el cajón del carrito con el
       HTML que se pintó al cargar la página: la clienta ve el carrito
       vacío y cree que no funcionó. */
    function agregarAlCarrito(id) {
      var T = window.theme;
      var nativo = !!(T && T.routes && T.utils && T.utils.fetchConfig && T.pubsub && T.pubsub.publish);

      if (!nativo) {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error("no se pudo agregar");
          return { irAlCarrito: true };
        });
      }

      /* cada sección que quiera refrescarse se anota en este evento */
      var secciones = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:bundled-sections", {
        bubbles: true, detail: { sections: secciones }
      }));

      var datos = new FormData();
      datos.append("id", id);
      datos.append("quantity", 1);
      datos.append("sections", secciones);
      datos.append("sections_url", window.location.pathname);

      var cfg = T.utils.fetchConfig("javascript");
      cfg.headers["X-Requested-With"] = "XMLHttpRequest";
      delete cfg.headers["Content-Type"];
      cfg.body = datos;

      return fetch(T.routes.cart_add_url, cfg).then(function (r) {
        return r.json();
      }).then(function (estado) {
        if (estado.status) throw new Error(estado.description || estado.message || "no se pudo agregar");
        return fetch(T.routes.cart_url, T.utils.fetchConfig("json", "GET")).then(function (r) {
          return r.json();
        }).then(function (carrito) {
          carrito.sections = estado.sections;
          T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: "lnd-guia-tallas", productVariantId: String(id), cart: carrito
          });
          document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: estado } }));

          var enPaginaCarrito = document.body.classList.contains("template-cart") ||
            (T.settings && T.settings.cartType === "page");
          var cajon = enPaginaCarrito ? null : document.querySelector("cart-drawer");
          return {
            cajon: cajon && typeof cajon.show === "function" ? cajon : null,
            irAlCarrito: enPaginaCarrito
          };
        });
      });
    }

    /* --- abrir y cerrar --- */
    var previo = null, scrollY = 0;

    function focosVisibles() {
      return Array.prototype.slice.call(caja.querySelectorAll(
        'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }

    function abrirModal() {
      previo = document.activeElement;
      scrollY = window.scrollY;
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
      requestAnimationFrame(function () {
        overlay.classList.add("is-open");
        q("[data-sg-close]").focus();
      });
    }
    /* sinFoco: al agregar al carrito el foco lo toma el cajón del tema,
       así que devolverlo al botón de la guía solo produce un salto */
    function cerrarModal(sinFoco) {
      overlay.classList.remove("is-open");
      document.body.style.overflow = "";
      var quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      setTimeout(function () { overlay.hidden = true; }, quieto ? 0 : 220);
      if (sinFoco !== true && previo && previo.focus) previo.focus();
      window.scrollTo(0, scrollY);
    }

    abrir.addEventListener("click", abrirModal);
    q("[data-sg-close]").addEventListener("click", function () { cerrarModal(); });
    overlay.addEventListener("mousedown", function (e) { if (e.target === overlay) cerrarModal(); });

    overlay.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.preventDefault(); cerrarModal(); return; }
      if (e.key !== "Tab") return;
      var f = focosVisibles();
      if (!f.length) return;
      var primero = f[0], ultimo = f[f.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    });

    /* --- arranque --- */
    if (unSoloMetodo(st.cat)) st.metodo = metodosDe(st.cat)[0].id;
    st.paso = primerPaso();

    /* Memoria (sección 8). Solo si la ficha sabe qué prenda es: sin
       data-sg-cat la guía pregunta la categoría y no hay a qué atar las
       medidas. Si están completas, la guía arranca en el resultado; si
       falta algo (por ejemplo la Línea, en una ficha que no la fija),
       arranca donde siempre pero con lo que ya se sabía marcado. */
    var mem = SALTA_CATEGORIA ? leerMemoria()[prendaDe(st.cat, PRODUCTO)] : null;
    var metodoValido = mem && metodosDe(st.cat).some(function (m) { return m.id === mem.metodo; });
    if (metodoValido) {
      st.metodo = mem.metodo;
      st.vals = {};
      Object.keys(mem.vals || {}).forEach(function (k) { st.vals[k] = mem.vals[k]; });
      st.ajuste = mem.ajuste || "regular";
      var completo = defs(st.cat, st.metodo).every(function (f) {
        return st.vals[f.key] != null && st.vals[f.key] !== "";
      });
      st.paso = completo ? 3 : 2;
    }

    render(false);
  }

  function arrancar() { document.querySelectorAll("[data-lnd-sg]").forEach(iniciar); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancar);
  else arrancar();
  document.addEventListener("shopify:section:load", arrancar);
})();